import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, watch } from 'vue';
import { useDebounceFn, useEventListener, useTextareaAutosize } from '@vueuse/core';
export default {
  __name: 'Signature',
  props: /*@__PURE__*/_mergeModels({
    signatureDefault: {
      type: String,
      required: true
    }
  }, {
    "modelValue": {
      "default": ''
    },
    "modelModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['onUpdate'], ["update:modelValue"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useTextareaAutosize = useTextareaAutosize(),
      textarea = _useTextareaAutosize.textarea,
      input = _useTextareaAutosize.input;
    var props = __props;
    var emit = __emit;
    var signature = _useModel(__props, "modelValue");
    watch(input, function (val) {
      return signature.value = val;
    });
    onMounted(function () {
      input.value = signature.value || props.signatureDefault;
    });
    useEventListener(textarea, 'keyup', useDebounceFn(function () {
      return emit('onUpdate', input.value);
    }, 1000));
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        "class": "font-size-12 font-weight-semibold"
      }, "—", -1)), _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(input) ? input.value = $event : null;
        }),
        ref_key: "textarea",
        ref: textarea,
        "class": "textarea-signature font-size-12 font-weight-semibold border-0 p-0 w-100 no-resize overflow-hidden"
      }, "\t", 512), [[_vModelText, _unref(input)]])], 64);
    };
  }
};